// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chartBox {
  display: flex;
  height: 100%;
}
@media screen and (max-width: 480px) {
  .chartBox {
    flex-direction: column;
  }
}
.chartBox .boxInfo {
  flex: 3 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@media screen and (max-width: 480px) {
  .chartBox .boxInfo {
    gap: 20px;
  }
}
.chartBox .boxInfo .title {
  display: flex;
  align-items: center;
  gap: 10px;
}
@media screen and (max-width: 1440px) {
  .chartBox .boxInfo .title {
    font-size: 14px;
  }
}
@media screen and (max-width: 1440px) {
  .chartBox .boxInfo h1 {
    font-size: 20px;
  }
}
.chartBox .chartInfo {
  flex: 2 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.chartBox .chartInfo .chart {
  width: 100%;
  height: 100%;
}
.chartBox .chartInfo .texts {
  display: flex;
  flex-direction: column;
  text-align: right;
}
.chartBox .chartInfo .texts .percentage {
  font-weight: bold;
  font-size: 20px;
}
@media screen and (max-width: 1440px) {
  .chartBox .chartInfo .texts .percentage {
    font-size: 16px;
  }
}
.chartBox .chartInfo .texts .duration {
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/components/chartBox/chartBox.scss","webpack://./src/styles/responsive.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,YAAA;AADF;ACIE;EDLF;IAKI,sBAAA;EAAF;AACF;AAEE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAAJ;ACPE;EDGA;IAOI,SAAA;EACJ;AACF;AACI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACN;ACOE;EDXE;IAMI,eAAA;EAEN;AACF;ACEE;EDDE;IAEI,eAAA;EACN;AACF;AAGE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AADJ;AAGI;EACE,WAAA;EACA,YAAA;AADN;AAII;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;AAFN;AAIM;EACE,iBAAA;EACA,eAAA;AAFR;ACtBE;EDsBI;IAKI,eAAA;EADR;AACF;AAGM;EACE,eAAA;AADR","sourcesContent":["@import \"../../styles/responsive.scss\";\n\n.chartBox {\n  display: flex;\n  height: 100%;\n\n  @include sm {\n    flex-direction: column;\n  }\n\n  .boxInfo {\n    flex: 3;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n\n    @include sm {\n      gap: 20px;\n    }\n\n    .title {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n\n      @include xxl {\n        font-size: 14px;\n      }\n    }\n\n    h1 {\n      @include xxl {\n        font-size: 20px;\n      }\n    }\n  }\n\n  .chartInfo {\n    flex: 2;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n\n    .chart {\n      width: 100%;\n      height: 100%;\n    }\n\n    .texts {\n      display: flex;\n      flex-direction: column;\n      text-align: right;\n\n      .percentage {\n        font-weight: bold;\n        font-size: 20px;\n\n        @include xxl {\n          font-size: 16px;\n        }\n      }\n      .duration {\n        font-size: 14px;\n      }\n    }\n  }\n}\n","$sm: 480px;\n$md: 768px;\n$lg: 1024px;\n$xl: 1200px;\n$xxl: 1440px;\n\n@mixin sm {\n  @media screen and (max-width: $sm) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media screen and (max-width: $md) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media screen and (max-width: $lg) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media screen and (max-width: $xl) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media screen and (max-width: $xxl) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
